import { render, staticRenderFns } from "./FullPrintableView.vue?vue&type=template&id=580944f6&scoped=true"
import script from "./FullPrintableView.vue?vue&type=script&lang=ts"
export * from "./FullPrintableView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580944f6",
  null
  
)

export default component.exports